var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37134 3.36914C3.01355 3.36914 2.70103 3.54959 2.52015 3.82181L8.09158 9.27717C8.29677 9.47808 8.60464 9.47808 8.80983 9.27717L14.3813 3.82181C14.2004 3.54959 13.8879 3.36914 13.5301 3.36914H3.37134ZM2.35547 5.06714V12.3215C2.35547 12.8726 2.80855 13.3162 3.37134 13.3162H13.5301C14.0929 13.3162 14.5459 12.8726 14.5459 12.3215V5.06714L9.52809 9.98046C8.93737 10.5589 7.96405 10.5589 7.37333 9.98046L2.35547 5.06714Z",
    fill: "#7886B0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpMailIcon);
export default __webpack_public_path__ + "static/media/HelpMailIcon.e08f7f245fc820882b45781a4a055296.svg";
export { ForwardRef as ReactComponent };